// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VNqq","type":"styles_type__36oEx","choices":"styles_choices__2hblA"};